export enum fromEnum {
	prelevement = 'prelevement',
	leaveDeposit = 'leaveDeposit'
}
